<div class="chart-container"
     #containerRef
     (appOnWindowResize)="onNgxChartResizedWithDirective()"
     (window:resize)="onNgxChartResized($event)"
     resizeWindowDebounceTime="500">
  <ngx-charts-bar-vertical
      [results]="data"
      [gradient]="displayOptions?.Gradient"
      [xAxis]="!displayOptions?.HideXAxis"
      [yAxis]="!displayOptions?.HideYAxis"
      [legend]="getLegendDisplayOptions()?.ShowLegend"
      [legendTitle]="getLegendDisplayOptions()?.LegendTitle"
      [legendPosition]="getLegendDisplayOptions()?.LegendPosition"
      [showXAxisLabel]="!displayOptions?.HideXAxisLabel"
      [showYAxisLabel]="!displayOptions?.HideYAxisLabel"
      [xAxisLabel]="displayOptions?.XAxisLabel"
      [yAxisLabel]="displayOptions?.YAxisLabel"
      [tooltipDisabled]="displayOptions?.TooltipDisabled"
      [scheme]="colorScheme"
      [maxXAxisTickLength]="displayOptions?.MaxXAxisTickLength"
      [trimYAxisTicks]="displayOptions?.TrimYAxisTicks"
      [view]="view"
      #chart>
    <ng-template #tooltipTemplate let-model="model"
                 *ngIf="displayOptions && !displayOptions?.TooltipDisabled && displayOptions?.TooltipText">
      <div [innerHTML]="getTooltipText(model)"></div>
    </ng-template>
  </ngx-charts-bar-vertical>
</div>
